// FounderLoginPage — connexion espace Founder Partner (light premium) (v5.9.0).
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import { founderApi, setFounderToken } from "@/lib/founderApi";

export default function FounderLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    if (e) e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await founderApi.post("/auth/login", { username, password });
      setFounderToken(data.token);
      navigate(data.must_change_credentials ? "/founder-onboarding" : "/founder-partner", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Connexion impossible. Réessayez.");
    } finally { setBusy(false); }
  };

  return (
    <div style={F.page} data-testid="founder-login-page">
      <div style={F.card}>
        <div style={F.logo}>AYA <span style={{ color: "#D4AF37" }}>★</span></div>
        <h1 style={F.h1}>Espace Founder Partner</h1>
        <p style={F.sub}>Accès privé — partenaire financier fondateur</p>
        <label style={F.label}><User size={13} /> Identifiant</label>
        <input data-testid="founder-username-input" style={F.input} value={username} autoComplete="username"
          onChange={(e) => setUsername(e.target.value)} placeholder="Votre identifiant" />
        <label style={F.label}><Lock size={13} /> Mot de passe</label>
        <input data-testid="founder-password-input" type="password" style={F.input} value={password} autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit(e)} placeholder="Votre mot de passe" />
        {error && <div style={F.error} data-testid="founder-login-error">{error}</div>}
        <button type="button" onClick={submit} disabled={busy || !username || !password} style={F.btn} data-testid="founder-login-submit">
          {busy ? "Connexion…" : "Se connecter"}
        </button>
      </div>
    </div>
  );
}

export const F = {
  page: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(160deg, #F6FBF8 0%, #EDF6F0 60%, #F9F6EC 100%)", fontFamily: "'Manrope', system-ui, sans-serif", padding: 18 },
  card: { width: "min(400px, 94vw)", background: "#FFFFFF", borderRadius: 20, padding: "30px 28px", boxShadow: "0 10px 40px rgba(6,40,26,0.08)", border: "1px solid rgba(16,185,129,0.15)" },
  logo: { fontSize: 24, fontWeight: 900, letterSpacing: 3, color: "#0B3D2A" },
  h1: { fontSize: 19, fontWeight: 800, color: "#0F1D16", margin: "14px 0 2px" },
  sub: { fontSize: 12.5, color: "#6B7F72", margin: "0 0 18px" },
  label: { display: "flex", alignItems: "center", gap: 5, fontSize: 11.5, fontWeight: 700, color: "#3E4F45", margin: "10px 0 5px" },
  input: { width: "100%", boxSizing: "border-box", padding: "11px 13px", borderRadius: 11, border: "1px solid #D7E4DB", fontSize: 14, color: "#0F1D16", outline: "none", background: "#FAFDFB" },
  error: { marginTop: 10, padding: "8px 12px", borderRadius: 9, background: "#FEF2F2", border: "1px solid #FECACA", color: "#B91C1C", fontSize: 12 },
  btn: { width: "100%", marginTop: 18, padding: "12px 0", borderRadius: 12, border: "none", cursor: "pointer", background: "linear-gradient(135deg,#10B981,#0B3D2A)", color: "#fff", fontSize: 14, fontWeight: 800 },
};
